{
  "welcome_back": "Welcome back",
  "golfer": "Golfer",
  "your_rounds": "Latest Rounds",
  "no_rounds_yet": "No rounds yet",
  "start_first_round_message": "Start your first round to track your golf scores!",
  "start_your_first_round": "Start Your First Round",
  "latest_registrations": {
    "title": "Latest Registrations",
    "show_more": "Show more"
  },
  "tabs": {
    "my_rounds": "My Rounds",
    "all": "All",
    "upcoming": "Upcoming"
  },
  "welcome": "Welcome,",
  "welcome_first": "Welcome to Impactia!",
  "empty_subtitle": "You don't have any rounds yet. Start tracking and see how your game improves.",
  "start_round": "Start round",
  "browse_calendar": "Browse competition calendar",
  "hcp": "HCP",
  "sections": {
    "ongoing": "Ongoing",
    "upcoming": "Upcoming",
    "past": "Past"
  },
  "manager": {
    "weather": {
      "loading": "Loading weather data…",
      "forecast_loading": "Loading forecast…",
      "forecast_unavailable": "Forecast unavailable",
      "error": "Error",
      "refresh": "Refresh weather",
      "updated": "Updated",
      "feels_like": "Feels like",
      "wind": "Wind m/s",
      "humidity": "Humidity %",
      "pressure": "Pressure hPa",
      "uv_index": "UV index",
      "rain_probability": "Rain prob. %",
      "station_suffix": "FMI",
      "time_prefix": "at",
      "days": {
        "su": "Sun",
        "ma": "Mon",
        "ti": "Tue",
        "ke": "Wed",
        "to": "Thu",
        "pe": "Fri",
        "la": "Sat"
      },
      "days_short": {
        "su": "SU",
        "ma": "MO",
        "ti": "TU",
        "ke": "WE",
        "to": "TH",
        "pe": "FR",
        "la": "SA"
      },
      "compass": {
        "n": "N",
        "ne": "NE",
        "e": "E",
        "se": "SE",
        "s": "S",
        "sw": "SW",
        "w": "W",
        "nw": "NW"
      },
      "conditions": {
        "clear": "Clear",
        "mostly_clear": "Mostly clear",
        "cloudy": "Cloudy",
        "foggy": "Foggy",
        "drizzle": "Drizzle",
        "rain": "Rain",
        "snow": "Snow",
        "rain_showers": "Rain showers",
        "snow_showers": "Snow showers",
        "thunderstorm": "Thunderstorm"
      }
    },
    "upcoming_competitions": {
      "title": "Competitions",
      "show_more": "Show more",
      "no_upcoming": "No upcoming competitions",
      "prev": "Previous competitions",
      "next": "Upcoming competitions"
    },
    "members": {
      "title": "Society Members",
      "invite": "Add members",
      "inviteModal": {
        "title": "Invite members",
        "tabs": {
          "email": "Email",
          "link": "Join link & QR",
          "ebirdie": "eBirdie"
        },
        "joinCode": {
          "description": "Share the join link or QR code so players can join the society themselves.",
          "regenerate": "Generate new code",
          "codeLabel": "Join code",
          "linkLabel": "Join link",
          "copyLink": "Copy link",
          "copied": "Copied",
          "qrHint": "Players can join by scanning the QR code or opening the link.",
          "shareQr": "Share QR code",
          "shareTitle": "Society join code",
          "error": "Failed to process the join code."
        },
        "ebirdieNoEmail": "No email address found for this player, so they cannot be invited.",
        "emailsLabel": "Email addresses",
        "emailPlaceholder": "member@example.com",
        "addAddress": "Add address",
        "removeEmail": "Remove address",
        "help": "We will send an invitation to each address by email. An address without an existing account will receive a registration link — membership is activated once the invitation is accepted in the app.",
        "send": "Send invitations",
        "resultSummary": "Invitations sent: {{invited}} new, {{already}} already on the list, {{invalid}} invalid",
        "errorGeneric": "Failed to send invitations."
      },
      "columns": {
        "name": "Name",
        "email": "Email",
        "status": "Status",
        "invited": "Invited",
        "joined": "Joined"
      },
      "status": {
        "invited": "Invited – no account",
        "awaiting": "Awaiting approval",
        "active": "Member"
      },
      "empty": "No members",
      "actions": "Actions",
      "select": "Select",
      "selectAll": "Select all",
      "delete": "Remove members",
      "deleteConfirm": {
        "header": "Remove members",
        "body": "Remove {{count}} members from the community? This cannot be undone.",
        "confirm": "Remove"
      },
      "deleteSuccess": "Removed {{count}} members",
      "deleteError": "Failed to remove members"
    }
  },
  "societyInvite": {
    "label": "Society Invitation",
    "body": "has invited you to become a member. As a member, you can view the society's events and register for them.",
    "decline": "Decline",
    "accept": "Accept"
  },
  "latest_scorecards": {
    "title": "Latest Scorecards",
    "empty": "No saved scorecards",
    "has_statistics": "Includes statistics",
    "types": {
      "competition": "Competition round",
      "handicap": "Handicap round",
      "regular": "Practice round"
    }
  },
  "latest_payments": {
    "title": "Latest Payments",
    "show_more": "Show more",
    "empty": "No payments"
  }
}
